
import { defineComponent, PropType } from 'vue'
import {
  BIconArrowClockwise,
  BIconArrowRight,
  BIconCheckLg,
  BIconInfoCircle,
  BIconExclamationTriangle,
  BIconXLg,
} from 'bootstrap-icons-vue'
import { FetchedData } from '@/services/api'

export default defineComponent({
  name: 'RequirementsView',
  components: {
    BIconArrowClockwise,
    BIconArrowRight,
    BIconCheckLg,
    BIconInfoCircle,
    BIconExclamationTriangle,
    BIconXLg,
  },
  props: {
    loading: Boolean,
    data: {
      type: Object as PropType<FetchedData>,
      required: true,
    },
  },
  methods: {
    refreshRequirements() {
      this.$emit('refresh')
    },

    nextStep() {
      if (this.data.extracted) {
        setTimeout(() => this.$emit('reload'))
        return
      }

      this.$emit('next')
    },

    translateRequirementHelp(requirement: string) {
      if (requirement.startsWith('extension-')) {
        const v = this.data.phpVersion

        return this.$t('requirements.help.extension', {
          command: `apt install curl php${v}-mysql php${v}-pgsql php${v}-sqlite php${v}-bcmath php${v}-mbstring php${v}-xml php${v}-curl php${v}-zip php${v}-gd`,
        })
      }

      if (requirement.startsWith('function-')) {
        return this.$t('requirements.help.function')
      }

      if (requirement === 'writable') {
        return this.$t('requirements.help.writable', {
          command: `chmod -R 755 ${this.data.path} && chown -R www-data:www-data ${this.data.path}`,
        })
      }

      if (requirement === 'writable' && !this.data.htaccess) {
        return this.$t('requirements.help.htaccess')
      }

      return this.$t(`requirements.help.${requirement}`)
    },

    translateRequirement(requirement: string) {
      if (requirement.startsWith('extension-')) {
        return this.$t('requirements.extension', {
          extension: requirement.replace('extension-', ''),
        })
      }

      if (requirement.startsWith('function-')) {
        return this.$t('requirements.function', {
          function: requirement.replace('function-', ''),
        })
      }

      return this.$t(`requirements.${requirement}`, {
        version: this.data.minPhpVersion,
      })
    },
  },
})
